import { InboxOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Alert, Flex, message, Space, Typography, Upload } from "antd";
import type { UploadProps } from "antd";
import { importCompanies } from "../../../lib/api/resources/companies";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "@rumbledirect/ui";

const { Dragger } = Upload;

export const CompanyImport = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState<File | null>(null);

  const mutation = useMutation({
    mutationFn: async () => {
      if (!file) throw new Error("Geen bestand geselecteerd");
      return importCompanies(file);
    },
    onSuccess: () => {
      message.success("Import succesvol gestart");
      navigate("/companies");
    },
    onError: () => message.error("Importeren mislukt"),
  });

  const props: UploadProps = {
    name: "file",
    multiple: false,
    beforeUpload: (f) => {
      setFile(f);
      return false; // prevent auto upload
    },
    accept: ".csv,text/csv,text/plain",
    maxCount: 1,
  };

  return (
    <Flex vertical gap={16}>
      <Card title="Bedrijven importeren">
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <Alert
            type="info"
            showIcon
            message={
              <span>
                Upload een CSV-bestand met bedrijven. Voorbeeldbestand:&nbsp;
                <a
                  href="https://cdn.rumbledirect.com/static/data-management/companies.csv"
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary-500 underline"
                >
                  companies.csv
                </a>
              </span>
            }
          />
          <Dragger {...props} disabled={mutation.isPending}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <Typography.Paragraph>
              Klik of sleep een CSV-bestand naar dit gebied om te uploaden
            </Typography.Paragraph>
          </Dragger>
          <div>
            <Button
              type="primary"
              onClick={() => mutation.mutate()}
              loading={mutation.isPending}
              disabled={!file}
            >
              Importeren
            </Button>
          </div>
        </Space>
      </Card>
    </Flex>
  );
};
